import script from "./FaqView.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqView.vue?vue&type=script&setup=true&lang=js"

import "./FaqView.vue?vue&type=style&index=0&id=cb999a8e&lang=scss"

const __exports__ = script;

export default __exports__